/* ==========================================================================
   BodyReset – Kaufweg-Paket (26.09.2026)
   1) Lieferdatum-Versprechen: füllt alle [data-br-eta]-Elemente (Produktseite + Warenkorb)
      mit einem Datumsbereich in Schweizer Zeit (Europe/Zurich).
      Werktage = Mo–Fr ohne eidgenössische Feiertage (Neujahr, Karfreitag, Ostermontag,
      Auffahrt, Pfingstmontag, 1. August, 25./26. Dezember).
      Anzahl Werktage kommt aus data-eta-min / data-eta-max (Versandrichtlinie).
   2) (entfernt 26.09.2026: Sticky-Leisten-Höhe für die WhatsApp-Blase, Blase gibt es nicht mehr)
   3) «Passend dazu» im Warenkorb: Schnell-Hinzufügen per AJAX + Horizon cart:update.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- 1. Lieferdatum ---------- */
  var WD = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

  function zurichToday() {
    try {
      var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Zurich', year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(new Date());
      var o = {};
      parts.forEach(function (p) { o[p.type] = p.value; });
      return new Date(Date.UTC(+o.year, +o.month - 1, +o.day));
    } catch (e) {
      var n = new Date();
      return new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate()));
    }
  }

  // Ostersonntag (Gauss/Meeus, gregorianisch)
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
      f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3),
      h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
      l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
      month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(y, month - 1, day);
  }

  var holidayCache = {};
  function holidays(y) {
    if (holidayCache[y]) return holidayCache[y];
    var DAY = 86400000, es = easter(y), set = {};
    [
      Date.UTC(y, 0, 1),        // Neujahr
      es - 2 * DAY,             // Karfreitag
      es + 1 * DAY,             // Ostermontag
      es + 39 * DAY,            // Auffahrt
      es + 50 * DAY,            // Pfingstmontag
      Date.UTC(y, 7, 1),        // Bundesfeiertag
      Date.UTC(y, 11, 25),      // Weihnachten
      Date.UTC(y, 11, 26)       // Stephanstag
    ].forEach(function (t) { set[t] = true; });
    holidayCache[y] = set;
    return set;
  }

  function isWorkday(d) {
    var wd = d.getUTCDay();
    if (wd === 0 || wd === 6) return false;
    return !holidays(d.getUTCFullYear())[d.getTime()];
  }

  function addWorkdays(start, n) {
    var d = new Date(start.getTime()), c = 0;
    while (c < n) {
      d = new Date(d.getTime() + 86400000);
      if (isWorkday(d)) c++;
    }
    return d;
  }

  function fmt(d) {
    return WD[d.getUTCDay()] + ', ' + d.getUTCDate() + '.' + (d.getUTCMonth() + 1) + '.';
  }

  function etaRange(min, max) {
    var t = zurichToday();
    return { from: fmt(addWorkdays(t, min)), to: fmt(addWorkdays(t, max)) };
  }
  window.brEtaRange = etaRange;

  function fillEta(root) {
    (root || document).querySelectorAll('[data-br-eta]:not([data-br-eta-done])').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-eta-min'), 10) || 2;
      var max = parseInt(el.getAttribute('data-eta-max'), 10) || 4;
      var r = etaRange(min, max);
      var lead = el.getAttribute('data-eta-lead') || 'Bestellst du heute, ist es voraussichtlich zwischen';
      var tail = el.getAttribute('data-eta-tail') || 'bei dir.';
      el.innerHTML = lead + ' <strong>' + r.from + '</strong> und <strong>' + r.to + '</strong> ' + tail;
      el.setAttribute('data-br-eta-done', '');
      el.hidden = false;
    });
  }

  /* ---------- 3. «Passend dazu» Schnell-Hinzufügen ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('br-xsell__form')) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    var id = parseInt((form.querySelector('[name="id"]') || {}).value, 10);
    if (!id) { form.submit(); return; }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'br-xsell',
            data: { source: 'br-xsell', itemCount: cart.item_count, cart: cart }
          }
        }));
      })
      .catch(function () { form.submit(); })
      .then(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  });

  /* ---------- Start + Nachziehen nach Horizon-Morphs ---------- */
  function run() { fillEta(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; run(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
